import React from 'react'

import type { GradientInfoHeaderContentBlock } from '@library/api-menu-experience'
import { GradientInfoHeader } from '@library/menu-page'

type GradientInfoHeaderContentBlockWrapperProps = {
  contentBlock: GradientInfoHeaderContentBlock
}

export const GradientInfoHeaderContentBlockWrapper = ({
  contentBlock,
}: GradientInfoHeaderContentBlockWrapperProps) => <GradientInfoHeader contentBlock={contentBlock} />
